import {ComplectationAttribute, isComplectationAttribute} from "./ComplectationAttribute";
import TypeCheck from "../../utils/Typecheck";
import {Group, isGroup} from "./Group";
import {Complect, isComplect} from "./Complect";
import {isSlot, Slot} from "./Slot";
import {isOption, Option} from "./Option";

export interface ComplectationBlock {
    id: string
    title: string
    attributes: ComplectationAttribute[]
    excludeIds: string[] | null
    dependsOnIds: string[] | null
    groups: Group[] | null
    complect: Complect | null
    slots: Slot | null
    items: Option[]
}

export const isComplectationBlock = (content: unknown): content is ComplectationBlock => {
    return TypeCheck.isObject(content)
        && TypeCheck.hasAll(
            content,
            ['id', 'title', 'excludeIds', 'dependsOnIds', 'attributes', 'groups', 'complect', 'slots', 'items']
        )
        && TypeCheck.isString(content.id)
        && TypeCheck.isString(content.title)
        && TypeCheck.isArrayOf(content.attributes, isComplectationAttribute)
        && (content.excludeIds === null || TypeCheck.isArrayOf(content.excludeIds, TypeCheck.isString))
        && (content.dependsOnIds === null || TypeCheck.isArrayOf(content.dependsOnIds, TypeCheck.isString))
        && (content.groups === null || TypeCheck.isArrayOf(content.groups, isGroup))
        && (content.complect === null || isComplect(content.complect))
        && (content.slots === null || isSlot(content.slots))
        && TypeCheck.isArrayOf(content.items, isOption)
}
